import { WSService } from "../../../utils/WSService";
import {
  IOAuthAuthorizeParams,
  IOAuthAuthorizeResponse,
  IOAuthAuthorizeSubmit,
  IOAuthRedirectResponse
} from "../types";

// Create a service instance for OAuth endpoints
const oauthApiService = new WSService("/users");

class OAuthService {
  /**
   * Get authorization details for OAuth consent screen
   */
  async getAuthorizeDetails(
    params: IOAuthAuthorizeParams
  ): Promise<IOAuthAuthorizeResponse> {
    const queryParams = new URLSearchParams({
      response_type: params.response_type,
      client_id: params.client_id,
      redirect_uri: params.redirect_uri,
      ...(params.scope && { scope: params.scope }),
      ...(params.state && { state: params.state }),
      ...(params.code_challenge && { code_challenge: params.code_challenge }),
      ...(params.code_challenge_method && {
        code_challenge_method: params.code_challenge_method
      })
    });

    const { data } = await oauthApiService.get<IOAuthAuthorizeResponse>(
      `/oauth/authorize?${queryParams.toString()}`
    );
    return data;
  }

  /**
   * Submit authorization decision (approve/deny)
   */
  async submitAuthorization(
    params: IOAuthAuthorizeSubmit
  ): Promise<IOAuthRedirectResponse> {
    const { data } = await oauthApiService.post<IOAuthRedirectResponse>(
      "/oauth/authorize",
      params
    );
    return data;
  }

  /**
   * Clear stored OAuth params
   */
  clearStoredOAuthParams(): void {
    sessionStorage.removeItem("oauth_authorize_params");
  }
}

export const oauthService = new OAuthService();
